export default __webpack_public_path__ + "static/media/codeBook.c8d74b65.jpg";